<template>
    <aside class="sidebar-wrap">
        <div class="sidebar">
            <div class="sidebar-content" :class="{ loading: loading }">
                <div class="sidebar-content__top" :class="{'tags-in-column': asset.tags && asset.tags.length > 1}">
                    <h3
                        class="sidebar-content__heading-detail heading heading--md"
                    >
                        <strong>Details</strong>
                    </h3>
                    <div class="sidebar-content__tag">
                        <div
                            v-if="asset.tags"
                            class="find-tags-wrap find-tags-wrap--small"
                        >
                            <ItemsVisualizer
                                v-if="asset.tags"
                                :default-items="asset.tags"
                                :removable="false"
                                :clickable="true"
                                :single="false"
                            />
                        </div>
                    </div>
                </div>
                <div class="separator separator--blue"></div>
                <ul class="sidebar-list">
                    <li class="sidebar-list__item">
                        Type:
                        <strong>{{ contentType() }}</strong>
                    </li>
                    <li class="sidebar-list__item">
                        Updated:
                        <strong>
                            <time datetime="asset.updated_at">
                                {{
                                    getHumanReadableDiffString(
                                        new Date(asset.updatedAt)
                                    )
                                }}
                            </time>
                        </strong>
                    </li>
                    <li class="sidebar-list__item">
                        Release:
                        <strong
                            ><time
                                v-if="asset.releasedAt"
                                datetime="asset.releasedAt"
                                >{{
                                    getHumanReadableDiffString(
                                        new Date(asset.releasedAt)
                                    )
                                }}</time
                            >
                            <span v-else>Not released</span></strong
                        >
                    </li>
                    <li
                        v-if="asset.contentType != types.CREATOR_BLUEPRINT"
                        class="sidebar-list__item"
                    >
                        Disable local hosting (P2P):
                        <strong>{{ asset.protected ? 'Yes' : 'No' }}</strong>
                    </li>
                    <li v-if="asset.revision" class="sidebar-list__item">
                        Version:
                        <strong>{{ changelogNumber(asset.revision) }}</strong>
                    </li>
                </ul>
                <div v-if="!prePublish">
                    <button
                        v-if="!isBlueprintAsset"
                        class="sidebar-content__button button button--xl button--yellow button--rounded button--full-width"
                        @click="openModal"
                    >
                        PLAY
                    </button>
                </div>
                <div
                    v-if="belongsToLoggedInUser"
                    class="sidebar-content__creator"
                >
                    <div class="sidebar-content__top">
                        <h3
                            class="sidebar-content__heading-review heading heading--md"
                        >
                            Creation Admin
                        </h3>
                    </div>

                    <div class="separator separator--blue"></div>
                    <ul class="sidebar-list">
                        <li class="sidebar-list__item">
                            Published:
                            <strong>
                                <span
                                    v-if="asset.published"
                                    title="Asset published"
                                >
                                    <PublishedIcon width="16" /> Yes
                                </span>
                                <!-- <span
                                    v-else-if="
                                        !asset.published &&
                                            asset.published_by_user
                                    "
                                    title="Asset awaiting approval"
                                >
                                    <AwaitingApprovalIcon width="16" /> Awaiting
                                    Approval
                                </span> -->
                                <span
                                    v-else-if="!asset.published"
                                    title="Asset unpublished"
                                >
                                    <UnpublishedIcon width="16" /> No
                                </span>
                            </strong>
                        </li>
                        <li class="sidebar-list__item">
                            Hidden:
                            <strong>{{ asset.hidden ? 'Yes' : 'No' }}</strong>
                        </li>
                        <li v-if="isBlueprintAsset" class="sidebar-list__item">
                            Archived:
                            <strong>{{ asset.archived ? 'Yes' : 'No' }}</strong>
                        </li>
                        <li
                            v-if="asset.contentType != types.CREATOR_BLUEPRINT"
                            class="sidebar-list__item"
                        >
                            Transactions:
                            <strong>
                                {{
                                    asset.monetizedActions.length > 0
                                        ? `Yes (${asset.monetizedActions.length})`
                                        : 'No'
                                }}</strong
                            >
                        </li>
                        <li
                            v-if="
                                asset.contentType != types.CREATOR_BLUEPRINT &&
                                    asset.monetizedActions.length > 0
                            "
                            class="sidebar-list__item"
                        >
                            Coyns earned: <strong>Coming soon</strong>
                        </li>
                        <li v-if="!prePublish" class="sidebar-list__item">
                            <router-link
                                :to="{
                                    name: MONETIZATION_DETAIL_PAGE_NAME,
                                    params: { id: asset.id },
                                }"
                            >
                                <button class="button">
                                    <div class="icon-wrapper">
                                        <monetization-details
                                            width="15"
                                            height="21"
                                            class="icon-place"
                                        ></monetization-details>
                                    </div>
                                    <span>Monetization Details</span>
                                </button>
                            </router-link>
                        </li>
                        <li v-if="!prePublish" class="sidebar-list__item">
                            <button class="button" @click="editAsset">
                                <div class="icon-wrapper">
                                    <edit-pen
                                        class="icon-place"
                                        width="20"
                                        height="24"
                                    ></edit-pen>
                                </div>
                                <span>Edit</span>
                            </button>
                        </li>
                        <li class="sidebar-list__item">
                            <button class="button" @click="toggleHide()">
                                <div class="icon-wrapper">
                                    <hide-show
                                        class="icon-place"
                                        width="24"
                                        height="16"
                                    ></hide-show>
                                </div>
                                <span v-if="hidden">Show</span>
                                <span v-if="!hidden">Hide</span>
                            </button>
                        </li>
                        <li v-if="!prePublish" class="sidebar-list__item">
                            <button class="button" @click="deleteAsset()">
                                <div class="icon-wrapper">
                                    <CloseIcon
                                        width="16"
                                        fill="#0a294a"
                                        class="icon-place"
                                    />
                                </div>
                                <span v-if="isBlueprintAsset">Archive</span>
                                <span v-else>Remove</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- TODO - report in API -->
            <!-- <button class="asset-item__info-link button" @click="reportAsset()">
                <ReportIcon width="11" fill="#556f8b" />
                Report
            </button> -->
            <div v-if="loading" class="sorting__loader loader-rounded"></div>
        </div>

        <PlayDialog ref="playDialog" />
    </aside>
</template>

<script>
import {
    MONETIZATION_DETAIL_PAGE_NAME,
    EDIT_ASSET_PAGE_NAME,
} from '@/router/pageNameConstants';

import DateTimeUtil from '@/lib/dateTimeUtil.js';
import { getContentType, types } from '@/lib/contentTypes.js';

import { mapGetters } from 'vuex';

import ItemsVisualizer from '@/components/common/ItemsVisualizer.vue';

//SVG
import PublishedIcon from 'Svgs/published.svg?inline';
import UnpublishedIcon from 'Svgs/unpublished.svg?inline';
import AwaitingApprovalIcon from 'Svgs/awaiting_approval.svg?inline';
import CloseIcon from 'Svgs/close.svg?inline';
import MonetizationDetails from 'Svgs/monetization_details.svg?inline';
import HideShow from 'Svgs/hide-show.svg?inline';
import EditPen from 'Svgs/edit-pen.svg?inline';
import ReportIcon from 'Svgs/report_flag.svg?inline';

export default {
    components: {
        ItemsVisualizer,
        PublishedIcon,
        UnpublishedIcon,
        AwaitingApprovalIcon,
        CloseIcon,
        MonetizationDetails,
        HideShow,
        EditPen,
        ReportIcon,
        PlayDialog: () =>
            import(
                /* webpackPrefetch: true */ '@/components/common/modal/PlayDialog.vue'
            ),
    },
    props: {
        asset: {
            type: Object,
            default: function() {
                return {};
            },
        },
      
        loading: {
            type: Boolean,
            default: false,
        },
        prePublish: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
          'asset.hidden'(newVal) {
            this.hidden = newVal;
        },
    },
    data() {
        return {
            hidden: false,
            defaultHidden: false,
            types,
            MONETIZATION_DETAIL_PAGE_NAME,
            EDIT_ASSET_PAGE_NAME,
            elementTop: 0,
            originalTop: 0,
            lastKnownScrollPosition: 0,
            ticking: false,
        };
    },
    computed: {
        ...mapGetters('user', {
            isLoggedIn: 'isLogged',
            userId: 'getUserId',
        }),
         isBlueprintAsset() {
            return [
                types.CREATOR_BLUEPRINT,
                types.GAME_BLUEPRINT,
            ].includes(this.asset.contentType);
        },
        routeName() {
            return this.$route.name;
        },
        belongsToLoggedInUser() {
            return this.asset.userId === this.userId;
        },
    },
    mounted() {
        this.defaultHidden = this.asset.hidden;
        this.hidden = this.defaultHidden;
    },
    methods: {
        openModal() {
            this.$refs.playDialog.init('Choose your platform', this.asset.id);
        },
        contentType() {
            return getContentType(this.asset.contentType);
        },
        editAsset() {
            this.$emit('edit', this.asset);
        },
        changelogNumber(changelog) {
            let change = changelog.toString();
            if (change.lastIndexOf('.') >= 0) {
                return change;
            } else {
                return change.concat('.0');
            }
        },
        toggleHide() {
            this.$emit('hide',  !this.hidden);
        },
        getHumanReadableDiffString: function(date) {
            return DateTimeUtil.getHumanReadableDiffString(date);
        },
        getFullDatetimeFormatted: function(date) {
            return DateTimeUtil.getFullDateTime(date);
        },
        reportAsset() {
            this.$emit('report', this.asset);
        },
        deleteAsset() {
            this.$emit('delete', this.asset);
        },
    },
};
</script>
<style lang="scss" scoped>
.sidebar-wrap {
    padding: 0 !important;
    position: relative;
    max-width: 845px;

    @media (max-width: $lg-down) {
        width: 100%;
    }

    .sidebar {
        padding: rem(15);

        @media (min-width: $md-up) {
            position: sticky;
            top: 78px;
        }

        @media (max-width: $lg-down) {
            margin: rem(20) auto;
            padding: 0;
        }

        .sidebar-content {
            width: 326px;
            border-radius: 6px;
            border: 1px solid $blue-main;
            padding: rem(25) rem(22);

            @media (max-width: $lg-down) {
                width: 100%;
            }

            &.loading {
                opacity: 0.1;
            }

            .sidebar-content__top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
                &.tags-in-column {
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-direction: column;
                }
            }

            .sidebar-content__button {
                height: 5rem;

                // @media (max-width: $xs-down) { // fixed button, overlaps with feedback
                //     position: fixed;
                //     width: 100%;
                //     left: 0;
                //     bottom: 0;
                //     margin: 0;
                //     z-index: 5000;
                //     font-size: 20px;
                //     font-weight: 700;
                //     letter-spacing: 1.33px;
                //     text-transform: uppercase;
                //     height: 4.5rem;
                //     display: flex;
                //     justify-content: center;
                //     align-items: center;

                //     &:before {
                //         content: url('~Sprites/play_symbol_triangle.svg');
                //         margin-right: rem(12);
                //         width: 13px;
                //     }
                // }
            }
        }

        .sidebar__lower-row {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .asset-item__info-link {
                all: unset;
                display: inline-block;
                border-radius: 4px;
                color: #556f8b;
                cursor: pointer;
                font-family: $palanquin-font;
                font-size: 18px;
                font-weight: 300;
                letter-spacing: 0.06px;
                transition: all $transition-values;
                position: relative;
                margin-top: 35px;
                padding: 10px 19px;
                background-color: #f4f5f6;

                &:hover {
                    background-color: $blue-lighter;
                }
            }
            .asset-item__edit-link {
                outline: 0;
                display: inline-block;
                border-radius: 4px;
                cursor: pointer;
                font-family: $palanquin-font;
                font-size: 18px;
                font-weight: 300;
                letter-spacing: 0.06px;
                transition: all $transition-values;
                position: relative;
                margin-top: 35px;
                padding: 10px 19px;
            }
        }
    }
}
.sidebar-list {
    @include listReset;

    position: relative;
    margin: rem(20) 0;

    &:last-child {
        margin-bottom: 0;
    }

    .sidebar-list__item {
        line-height: 1.8;
        color: #22354a;
        font-size: rem(18);
        font-weight: 400;
        letter-spacing: 0.06px;
        line-height: 29px;

        &--favorite {
            margin-bottom: 10px;
        }

        button {
            display: flex;
            align-items: center;
            text-transform: capitalize;
            opacity: 0.75;
            color: #0a294a;
            margin: 7px 0;
            outline: 0;
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0.06px;
            line-height: 29px;
            transition: opacity $transition-values;

            &:last-child {
                margin-bottom: 0;
            }

            .icon-wrapper {
                display: flex;
                justify-content: flex-start;
                width: 30px;
            }

            &:hover {
                opacity: 1;
            }
        }
    }

    .sidebar-list__button {
        width: 100%;
        font-size: 0.9rem;
        letter-spacing: 0.05em;
        padding: 0.5em 2.5em;
    }
}
</style>
